import { GcTextColor, gcTextColors } from '@ip-only/front-end-library';
import {
  ReportTypes,
  SharepointExportItemStatus,
} from '../../entities/sharepoint-export-entities';

enum ReportTypeDod {
  STATUS_DONE = 'STATUS_DONE',
  STATUS_RESTORED = 'STATUS_RESTORED',
  FILLED_AND_PERFORMED = 'FILLED_AND_PERFORMED',
}

export const exportableReportsCompletedData: {
  reportType: ReportTypes;
  dod: ReportTypeDod;
}[] = [
  { reportType: ReportTypes.HP, dod: ReportTypeDod.STATUS_DONE },
  { reportType: ReportTypes.HC, dod: ReportTypeDod.FILLED_AND_PERFORMED },
  { reportType: ReportTypes.CABINET, dod: ReportTypeDod.STATUS_DONE },
  { reportType: ReportTypes.MANHOLE, dod: ReportTypeDod.STATUS_DONE },
  { reportType: ReportTypes.HUB, dod: ReportTypeDod.STATUS_DONE },
  { reportType: ReportTypes.SITE, dod: ReportTypeDod.STATUS_DONE },
  { reportType: ReportTypes.SPAN, dod: ReportTypeDod.STATUS_RESTORED },
];

export const tableDetailsData: string[] = [
  'totalAmount',
  'unexported',
  'status',
  'other',
];

export const statusForExportData: {
  status: SharepointExportItemStatus;
  color: GcTextColor;
}[] = [
  { status: SharepointExportItemStatus.READY, color: gcTextColors.primary },
  {
    status: SharepointExportItemStatus.IN_PROGRESS,
    color: gcTextColors['info-strong'],
  },
  { status: SharepointExportItemStatus.COMPLETED, color: gcTextColors.success },
  { status: SharepointExportItemStatus.NONE, color: gcTextColors.secondary },
];
